/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2022-11-05 22:03:17
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-08-04 17:34:50
 * @FilePath: /wemeet-web-activity/src/utils/validator.tsx
 * @Description: 统一校验字段
 */
export class Validator {
  /**
   * 是否是国内手机号
   * @param v
   */
  static isPhone(v: string) {
    return v && /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/.test(v);
  }

  /**
   * 是否是海外手机号
   * @param v
   */
  static isPhoneLikeCode(v: string) {
    return v && /^\d+$/.test(v);
  }

  static isEmail(v: string) {
    return v && /^[\w.-]+@[0-9a-z-]+(\.[a-z]+){1,2}$/.test(v);
  }

  static isUserName(v: string) {
    return v && v.length <= 20;
  }

  static isSmsCode(v: string) {
    return v && /\d{4}/.test(v);
  }

  // 身份证验证
  static isIdCard(v: string) {
    return (
      v &&
      /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/.test(
        v,
      )
    );
  }

  // 银行卡,先不校验吧
  static isBankCard() {
    return true;
  }
}

// 控制输入只能保留两位小数
export const clearNoNum = function (val: string) {
  let value: any = val.replace(/[^\d.]/g, ''); // 清除“数字”和“.”以外的字符
  value = value.replace(/^\./g, ''); // 验证第一个字符是数字
  value = value.replace(/\.{2,}/g, '.'); // 只保留第一个. 清除多余的
  value = value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
  value = value.replace(/^(-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); // 只能输入两个小数
  if (value.indexOf('.') < 0 && value !== '') {
    // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
    value = parseFloat(value);
  }
  return value || 0;
};
